"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TypesModel {
    constructor(object) {
        this.companyTypes = [];
        this.compTypes = [];
        this.contactTypes = [];
        this.contractTypes = [];
        this.listingTypes = [];
        this.propertyTypes = [];
        this.pursuitTypes = [];
        if (object) {
            this.companyTypes = object.companyTypes || [];
            this.compTypes = object.compTypes || [];
            this.contactTypes = object.contactTypes || [];
            this.contractTypes = object.contractTypes || [];
            this.listingTypes = object.listingTypes || [];
            this.propertyTypes = object.propertyTypes || [];
            this.pursuitTypes = object.pursuitTypes || [];
        }
    }
}
exports.TypesModel = TypesModel;
//# sourceMappingURL=types.model.js.map